import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import { WarrantyClaimNoteStatusEnum } from 'api-new/generated';
import clsx from 'clsx';
import { FC } from 'react';

const STATUS_UI_MAP: Record<
  WarrantyClaimNoteStatusEnum,
  {
    className: string;
    icon?: React.ReactNode;
    text: string;
  }
> = {
  [WarrantyClaimNoteStatusEnum.Approved]: {
    className: styles.greenBlock,
    text: 'Approved'
  },
  [WarrantyClaimNoteStatusEnum.Submited]: {
    className: styles.blueBlock,
    text: 'Submitted'
  },
  [WarrantyClaimNoteStatusEnum.Canceled]: {
    className: '',
    text: 'Canceled'
  },
  [WarrantyClaimNoteStatusEnum.Closed]: {
    className: '',
    text: 'Closed'
  },
  [WarrantyClaimNoteStatusEnum.InProgress]: {
    className: styles.yellowBlock,
    text: 'In Progress'
  },
  [WarrantyClaimNoteStatusEnum.NotComplited]: {
    className: '',
    text: 'Not Completed'
  }
};

const isStatus = (value: number): value is WarrantyClaimNoteStatusEnum =>
  Object.values(WarrantyClaimNoteStatusEnum).includes(value);

export const StatusCell: FC<{ data: WarrantyLogModel }> = ({ data }) => {
  if (isStatus(data.status ?? -1))
    return (
      <div className="mt-2">
        <span className={clsx(STATUS_UI_MAP[data.status!].className, 'text-nowrap')}>
          {STATUS_UI_MAP[data.status!].icon} {STATUS_UI_MAP[data.status!].text}
        </span>
      </div>
    );

  return null;
};
